import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import NoDataFound from "../NoDataFound";
import { maskEmail } from "../../crm/customer/Utility";

const StaticList = ({ columnsData, rowsData, loading, currentPage }) => {
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    setColumns(columnsData);
    setRows(rowsData);
  }, [columnsData, rowsData]);

  const getDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    });
  };

  function getTableBody() {
    if (loading) {
      return (
        <tr>
          <td colSpan={6 + 1} style={{ textAlign: "center", height: "370px" }}>
            <div className="loader-new"></div>
          </td>
        </tr>
      );
    }

    if (rows.length === 0) {
      return (
        <tr>
          <td colSpan={6 + 1} style={{ textAlign: "center" }}>
            <NoDataFound title="No Data Found" />
          </td>
        </tr>
      );
    }

    return rows.map((item, rowIndex) => {
      return (
        <tr key={rowIndex}>
          <td className={item.chat_read != 0 ? "fontweightactive" : ""}>
            <NavLink
              to={{
                pathname: `/chat/${item.customer_tattle_uuid}`,
                state: { pageNumber: currentPage },
              }}
              className="chat-link"
            >
              {item.customer_tattle_uuid}
            </NavLink>
          </td>

          <td className={item.chat_read != 0 ? "fontweightactive" : ""}>
            {item.name &&
              item.name.slice(0, 20) + (item.name.length > 20 ? "..." : "")}
            {/* <span className="chat-badge">{item.line}</span> */}
          </td>

          <td className={item.chat_read != 0 ? "fontweightactive" : ""}>
            {item.email && item.email.length > 50
              ? maskEmail(item.email.slice(0, 50) + "...", 2, "email")
              : maskEmail(item.email, 2, "email")}
            {/* <span className="chat-badge">{item.line}</span> */}
          </td>
          <td className={item.chat_read != 0 ? "fontweightactive" : ""}>
            {" "}
            {/* {item.country && (
              <img
                src={`https://flagcdn.com/48x36/${
                  item.country_code && item.country_code.toLowerCase()
                }.png`}
                width="14px"
              />
            )} */}
            &nbsp;
            {item.country &&
              item.country.charAt(0).toUpperCase() +
              item.country.slice(1).toLowerCase()}
            {/* <span className="chat-badge">{item.line}</span> */}
          </td>

          <td className={item.chat_read != 0 ? "fontweightactive" : ""}>
            {item.preview && item.preview.length > 22
              ? item.preview.slice(0, 22) + "..."
              : item.preview}
            {/* <span className="chat-badge">{item.line}</span> */}
          </td>
          {/* <td className={item.chat_read != 0 ? "fontweightactive" : ""}>
            {item.agent_names &&
              item.agent_names.slice(0, 20) +
                (item.agent_names.length > 20 ? "..." : "")}
            {/* <span className="chat-badge">{item.line}</span> 
          </td> */}
          <td className={item.chat_read != 0 ? "fontweightactive" : ""}>
            {item.chat_status && item.chat_status.toLowerCase() === "missed"
              ? "Offline"
              : item.agent_names &&
              (item.agent_names.charAt(0).toUpperCase() + item.agent_names.slice(1)).slice(0, 20) +
              (item.agent_names.length > 20 ? "..." : "")}
          </td>
          <td className={item.chat_read != 0 ? "fontweightactive" : ""}>
            {item.campaign_source ? item.campaign_source : "N/A"}
          </td>
          {/* <td>
            {item.idea &&
              item.idea.map((idea, ideaIndex) => (
                <React.Fragment key={ideaIndex}>
                  <a
                    href={`https://tattle.allthingsott.com/tattle/ideas/${idea}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {idea}
                  </a>
                  {ideaIndex !== item.idea.length - 1 && ", "}
                </React.Fragment>
              ))}
          </td> */}

          <td className={item.chat_read != 0 ? "fontweightactive" : ""}>
            {getDate(item.timestamp)}
          </td>
          {/* const options = col.hasOwnProperty("options")
                ? col.options
                : null;

              if (options) {
                const val = options.find(
                  (option) => option.id || option._id === item[col.field]
                );
                return (
                  <td key={colIndex}>
                    {val ? val.value || val.option_name : item[col.field]}
                  </td>
                );
              }

              return <td key={colIndex}>{item[col.field]}</td>; */}
        </tr>
      );
    });
  }

  return (
    <div className="body-content live-chat-transcript" style={{ marginTop: '5px' }}>
      <div 
        className="table-wrap"
        style={{ padding: "0 5px 0 5px", minHeight: "60vh" }}
      >
        <table style={{ tableLayout: "fixed" }}>
          <thead>
            <tr>
              <th width="70">ID </th>
              <th width="140">Name</th>
              <th width="220">Email</th>
              <th width="130">Country</th>
              <th width="250">Summary</th>
              <th width="100">Agent</th>
              <th width="110">Source</th>
              <th width="100">Date</th>
            </tr>
          </thead>
          <tbody>{getTableBody()}</tbody>
        </table>
      </div>
    </div>
  );
};

export default StaticList;



// WEBPACK FOOTER //
// ./src/components/chat/components/StaticList.js